<template>
    <div class="leftMenu fl" ref="leftMenu">
        <div class="nav clearfix">
            <span class="navLi curr" v-if="$route.meta.pageType === 2 || $route.meta.pageType === 3">数据分类</span> 
            <!-- <span class="navLi curr" v-if="$route.meta.pageType === 3">事件分类</span>  -->
            <span class="navLi curr" v-if="$route.meta.pageType === 4">相关栏目</span> 
            <span class="navLi curr" v-if="$route.meta.pageType === 6">相关标签</span> 
        </div>
        <ul class="typeLi clearfix" v-if="$route.query.api_secret&&($route.meta.pageType === 2 || $route.meta.pageType === 3)">
            <li class="cp" :class="{'cur':curType === item.name}" v-for="(item,index) in typeLi" :key="index">
                <router-link :to="{path:'newsn',query:{type:item.name,api_secret:$route.query.api_secret}}" v-if="$route.meta.pageType === 2">
                    <i :class="'icons icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </router-link>
                <router-link :to="{path:'eventsn',query:{type:item.name,api_secret:$route.query.api_secret}}" v-if="$route.meta.pageType === 3">
                    <i :class="'icons icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </router-link>
            </li>
        </ul>
        <ul class="typeLi clearfix" v-if="!$route.query.api_secret&&($route.meta.pageType === 2 || $route.meta.pageType === 3)">
            <li class="cp" :class="{'cur':curType === item.name}" v-for="(item,index) in typeLi" :key="index">
                <router-link :to="{path:'news',query:{type:item.name}}" v-if="$route.meta.pageType === 2">
                    <i :class="'icons icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </router-link>
                <router-link :to="{path:'events',query:{type:item.name}}" v-if="$route.meta.pageType === 3">
                    <i :class="'icons icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </router-link>
            </li>
        </ul>
        <!-- <ul class="typeLi" v-if="$route.meta.pageType === 3">
            <li class="cp" :class="{'cur':curType === item.id}" v-for="(item,index) in typeLi" :key="index">
                <router-link :to="{path:'events',query:{type:item.id}}" >
                    <i :class="'icons icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </router-link>
            </li>
        </ul> -->
        <ul class="typeLi clearfix ac fs14" v-if="$route.meta.pageType === 4">
            <li class="cp" :class="{'cur':curType === item}" v-for="(item,index) in typeLi" :key="index">
                <router-link class="ovhidden" :to="{path:'viewpoint',query:{type:item}}" >
                    <span>{{item}}</span>
                </router-link>
            </li>
        </ul>
        <ul class="typeLi clearfix ac fs14" v-if="$route.meta.pageType === 6">
            <li class="cp" :class="{'cur':curType === item}" v-for="(item,index) in typeLi" :key="index">
                <router-link class="ovhidden" :to="{path:'eventTag',query:{type:item}}" >
                    <span>{{item}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "left",
    props: '',
    data() {
        return {
            curType:this.$route.query.type,
            typeArr:[
                {icon:'tpall',name:'全部'},
                {icon:'sh',name:'社会'},
                {icon:'sz',name:'时政'},
                {icon:'js',name:'军事'},
                {icon:'fz',name:'法治'},
                {icon:'kj',name:'科技'},
                {icon:'cj',name:'财经'},
                {icon:'wh',name:'文化'},
                {icon:'jy',name:'教育'},
                {icon:'jk',name:'健康'},
                {icon:'ly',name:'旅游'},
                {icon:'gy',name:'公益'},
                {icon:'jt',name:'交通'},
                {icon:'ms',name:'民生'},
                {icon:'ty',name:'体育'},
                {icon:'qc',name:'汽车'},
                {icon:'ss',name:'时尚'},
                {icon:'ly',name:'旅行'},
                {icon:'yl',name:'娱乐'},
                {icon:'ls',name:'历史'},
                {icon:'msh',name:'美食'},
                {icon:'yx',name:'游戏'},
                {icon:'fc',name:'房产'},
                {icon:'wxu',name:'文学'},
                {icon:'dm',name:'动漫'},  
                {icon:'neny',name:'能源'},
                {icon:'nongy',name:'农业'}, 
            ],
            typeLi:[],
            typeTag:[],
            apiSecret : this.$route.query.api_secret||'',
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            if(that.curType == undefined){
                that.curType = '全部';
            }
            that.dataAjax();
        }) 
    },
    methods: {
        dataAjax(){
            let that = this,url='';
            let parent = that.$parent.$parent;
            if(that.$route.meta.pageType ==4){
                that.$api.get('viewpoint/type/list',{api_secret:that.apiSecret},r=>{
                    parent.returnCode(r,function(){
                        that.typeLi = r.data;
                    })
                });
            }else if(that.$route.meta.pageType ==6){
                that.$api.get('hotnews/index/tag-list',{api_secret:that.apiSecret},r=>{
                    parent.returnCode(r,function(){
                        that.typeLi = r.data;
                    })
                });
            }else{
                // if(that.$route.meta.pageType ==2){
                //     url = 'news/index/news-type';
                // }else if(that.$route.meta.pageType ==3){
                //     url = 'hotnews/index/hot-news-type';
                // }
                url = 'news/index/news-type';
                that.typeLi=[{icon:'tpall',name:'全部'}];
                that.$api.get(url,{api_secret:that.apiSecret},r=>{
                    parent.returnCode(r,function(){
                        that.typeTag = r.data; 
                        for (let key in r.data) {
                            let ele = r.data[key];
                            let tmp = {}
                            that.typeArr.forEach(e => {
                                if(ele == e.name){
                                    tmp.name = ele;
                                    tmp.icon = e.icon;
                                    tmp.id = key;
                                    that.typeLi.push(tmp);
                                }
                            });
                        }
                    });
                });
            }
        },
    },
    watch: {
    }
}
</script>
<style lang="" scope>
    .leftMenu{width:210px;left:0;top:65px;bottom:0;background:var(--left-bg);z-index:100;}
</style>



// WEBPACK FOOTER //
// src/components/left.vue